import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Coins } from "lucide-react";
import { authAxios } from "../utils/auth";

/**
 * Desktop-only coin-balance pill for page headers. Hidden on mobile
 * (the mobile hamburger menu carries a highlighted "coins. Add more"
 * block instead — see MainMenu.jsx). Clicking the pill routes to
 * /plans and remembers the origin so PaymentSuccess can return the
 * user to the page they came from.
 */
export default function CoinBalancePill() {
  const navigate = useNavigate();
  const location = useLocation();
  const [balance, setBalance] = useState(null);

  useEffect(() => {
    let alive = true;
    authAxios.get("/credits/balance")
      .then((r) => { if (alive) setBalance(r?.data?.balance ?? null); })
      .catch(() => { if (alive) setBalance(null); });
    return () => { alive = false; };
  }, []);

  return (
    <button
      type="button"
      onClick={() =>
        navigate("/plans?tab=topup", { state: { from: location.pathname + location.search } })
      }
      className="hidden sm:flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-amber-500/10 border border-amber-500/30 text-amber-400 hover:bg-amber-500/20 hover:text-amber-300 transition-colors"
      data-testid="header-coin-pill"
      title="Top up coins"
    >
      <Coins className="w-4 h-4" />
      <span className="text-sm font-medium tabular-nums">
        {balance !== null ? balance.toLocaleString() : "—"}
      </span>
    </button>
  );
}
